import { useMutation, useQueryClient } from "react-query";
import { addTeacher } from "api/services/teachers";
import { ETeachersQueryKeys } from "api/endpoints/teachers";
import { logError } from "utils/notifications";
import { TTeacher, TTeacherAddRequestBody } from "types/api/teacher";
import { TApiError } from "types/api/error";

export const useAddTeacher = () => {
  const queryClient = useQueryClient();
  return useMutation<TTeacher, TApiError, TTeacherAddRequestBody>(addTeacher, {
    onSuccess: () => {
      queryClient.invalidateQueries(ETeachersQueryKeys.getTeachers);
    },
    onError: (error) => logError({ error }),
    retry: false,
  });
};
